import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'
import { getPages } from 'component/pagination/utils'

import {
  FETCH_QUERY_LOG_REQUEST,
  FETCH_QUERY_LOG_SUCCESS,
  FETCH_QUERY_LOG_ERROR,
  FETCH_QUERY_LOG_FILTER,
  CLEAR_QUERY_LOG,
} from 'actionTypes'

const DEFAULT_PAGE = 1
const DEFAULT_SIZE = 10

export const fetchQueryLog = (token, param, signalController = false) => (dispatch) => {
  dispatch(fetchQueryLogRequest())

  const page = param.page || DEFAULT_PAGE
  const size = param.size || DEFAULT_SIZE

  const params = {
    ...param,
    offset: size * page - size,
    page,
    size,
  }

  const onClose = () => dispatch(hideSpinner())
  const onError = (error) => {
    dispatch(fetchQueryLogError(error))
    dispatch(hideSpinner())
  }

  const onMessage = (response) => {
    if (signalController && signalController.signal.aborted) {
      return
    }

    if (response && response.data && response.data.pages && response.data.resultList) {
      dispatch(clearQueryLog())
      dispatch(getPages(response.data.pages))
      dispatch(fetchQueryLogSuccess(response.data))
      dispatch(hideSpinner())
    }

  }

  const abort = () => {
    if (signalController) {
      signalController.abort()
    }
    dispatch(hideSpinner())
  }

  dispatch(showSpinner("", true, abort))

  return new Api(token, dispatch)
    .eventSourceStream(API_URL.QUERY_LOG_LIST, params, null, signalController, onMessage, onClose, onError)
    .catch((error ) => onError(error))
}

export const fetchQueryLogRequest = () => ({
  type: FETCH_QUERY_LOG_REQUEST,
})

export const fetchQueryLogSuccess = (data) => ({
  type: FETCH_QUERY_LOG_SUCCESS,
  payload: data.resultList,
})

export const fetchQueryLogError = (error) => ({
  type: FETCH_QUERY_LOG_ERROR,
  payload: error,
})

export const fetchFilter = (filter) => ({
  type: FETCH_QUERY_LOG_FILTER,
  payload: filter || {},
})

export const clearQueryLog = () => ({
  type: CLEAR_QUERY_LOG,
})
